import React, { useState, useEffect } from 'react';
import Navbar from '../../../ReusableBlocks/Navbar';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNewContent } from '../../../Redux/Dashboard/External/Whatsnew/WhatNewAction';
import { Link, useNavigate } from "react-router-dom";
import * as PATH from '../../../CentralisedLink'
import Swal from 'sweetalert2'; // Ensure Swal is imported if it's being used
import { normalizeMediaUrl } from '../../../Utils/mediaUrls';

const What = () => {
    const dispatch = useDispatch();

    // Loading
    const isLoading = useSelector(state => state.whatNewReducer?.loading);
    // Error
    const errorMessage = useSelector(state => state.whatNewReducer?.error);
    // Data 
    const data = useSelector(state => state.whatNewReducer?.newContent);

    useEffect(() => {
        dispatch(fetchNewContent());
    }, [dispatch]);

    // Profile Fetching Error 
    useEffect(() => {
        if (errorMessage && errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.') {
            Swal.fire({
                title: 'Error',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'Retry',
                showCancelButton: true,
                customClass: {
                    title: 'my-custom-title-of-pop-login',
                    confirmButton: 'my-custom-button-of-pop',
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        }
    }, [errorMessage]);



    const formatDate = (dateString) => {
        const options = { day: 'numeric', month: 'short', year: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-US', options);
      };

    return (
        <>
            {isLoading && <LoadingScreen text="Loading..." />}
            <Navbar />
            <div className='FAQ-PAGE-BACKGROUND'>
                <div className='container'>
                    <br></br>
                    <div className="row">
                        {data && data.length > 0 ? (
                            data.map((item, index) => (
                                <div className="col-md-4 mb-3" key={index}>
                                    <div className='whats-new-card' style={{ backgroundImage: `linear-gradient(to bottom, transparent, #000), url(${normalizeMediaUrl(item.thumbnail, 'background')})` }}>
                                        <div className='card-matter'>
                                            <p className='card-matter-date'>{formatDate(item.releaseDate)}</p>
                                            <div className='card-matter-fixed-height'>
                                            <h5 className='card-matter-feature-title'>{item.title}</h5>
                                            <p className='card-matter-details'>{item.shortDescription}</p>
                                            </div>
                                            <Link style={{ textDecoration: 'none', color: 'black' }} to={`${PATH.WHAT_NEW_PATH}${item._id}`}>
                                                <p className='card-matter-learnmore'>Learn More {`>>>`}</p>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-md-12">
                                <p>No content available</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default What;
